module.exports = __webpack_public_path__ + "static/img/20201215.503bfc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20201215.jpg
// module id = rgm5
// module chunks = 99